<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('paterno')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Representante Legal del {{title}}
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p> 
            <p align="justify">
              Apellido Paterno *
            </p>
            <div>            
              <md-field :class="getValidationClass('paterno')">
                <md-input type="text" id="nombreparticipetitular" name="paterno" placeholder="Su respuesta" v-model="form.paterno" v-on:keypress="isLetter($event, 0)"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.paterno.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.paterno.alpha">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('materno')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido Materno *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('materno')">
                <md-input type="text" id="materno" name="materno" placeholder="Su respuesta" v-model="form.materno" v-on:keypress="isLetter($event, 0)"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.materno.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.materno.alpha">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombres')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Nombre(s) *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('nombres')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="form.nombres" v-on:keypress="isLetter($event, 0)"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nombres.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nombres.alpha">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>               

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Documento de identidad *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.docIdentidad" value="DNI">DNI</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="CE">Carné Extranjería</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="PAS">Pasaporte</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidad')">
                <span class="md-error" v-if="!$v.form.docIdentidad.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de documento de identidad *
          </md-card-header>
          <md-card-content>

            <div>
              <md-field :class="getValidationClass('nroIdentidad')">
                <md-input type="text" id="nroIdentidad" name="nroIdentidad" placeholder="Su respuesta" v-model="form.nroIdentidad" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nroIdentidad.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-else-if="!$v.form.nroIdentidad.valDoc">Formato inválido</span>
              <span class="md-error" v-else-if="!$v.form.nroIdentidad.minLength">Formato inválido</span> 
              </md-field>

            </div>
          </md-card-content> 
        </md-card>

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('capacidadRpteLegal')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Capacidad Legal del Representante Legal *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.capacidadRpteLegal" value="Si">Sí</md-checkbox>
                <md-checkbox v-model="form.capacidadRpteLegal" value="No">No</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('capacidadRpteLegal')">
                <span class="md-error" v-if="!$v.form.docIdentidad.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>
        <md-card class="md-elevation-0 m-5" :class="getValidationClass('rptefiledni')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Aquí adjuntar ambas caras de su DNI. *
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Adjuntar DNI u otro documento de identidad (ambas caras) en formato pdf, jpg, png.
            </p>
            <div v-if="data.allowUpload">
              <md-field>
                <md-file v-model="form.rptefiledni" @md-change="uploadFile" accept="image/*, .pdf" />

                <div class="md-layout" v-show="!showPorcentaje">
                  <div class="md-layout-item" style="margin-left:36px">
                    <md-progress-bar class="md-accent" md-mode="determinate" :md-value="uploadPercentage" :md-buffer="buffer"></md-progress-bar>
                  </div>  
                </div>
                <div class="md-layout" v-show="showPorcentajeSuccess">
                  <div class="md-layout-item" style="position:relative">
                    <div style="position:absolute; right:0">
                      <md-icon class="md-primary">check_circle</md-icon>
                    </div>
                    
                  </div>
                </div>

              </md-field>
            </div>

            <div class="cardDownload">
              <md-card class="cardDetail md-elevation-0" v-show="data.showFile" >
                <md-card-media>
                  <a href="javascript:;" @click="downloadFileRoot"><img :src="file" width="30" height="30"></a>
                </md-card-media>
              </md-card>

            </div>            

            <div class="radioform" :class="getValidationClass('rptefiledni')">
              <span class="md-error" v-if="!$v.form.rptefiledni.required">Esta respuesta es obligatoria.</span>
            </div>            
          
          </md-card-content> 
        </md-card>                   

        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
 import { alpha, alpha1, alpha2, alpha3, valDoc } from '../variables'
import {
  required,
  minLength,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  props:["title", "data",],
  name: 'Item2',
  data: () => ({
    form:{
    },
    uploadPercentage: 0,
    showUploadPercentage:false
  }),

  mounted: function(){
    this.form = this.$store.state.item.item2
    //this.$store.dispatch("back", false);    
  },
  validations(){
    var validate = {
      form: {
        paterno: {required, alpha},
        materno: {required, alpha},
        nombres: {required, alpha},
        docIdentidad: {required,},
        nroIdentidad: {required, valDoc, minLength: minLength(3)},
        capacidadRpteLegal: {required,},
        rptefiledni: { required,}
      }        
    }
    return validate;
  },
  methods: {
    downloadFileRoot(){
      this.$emit('downloadFile', {item: this.$options.name, campo:"rptefiledni"})
    },
    isLetter(e, i) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      let validate;
      switch (i) {
        case 0:
          validate = alpha
          break;
        case 1:
          validate = alpha1
          break;          
        case 2:
          validate = alpha2
          break;
        case 3:
          validate = alpha3
          break;                    
      }

      if(validate(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },    
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item2
    },   
    uploadFile(e){
      var data = new FormData();
      var that = this;
      var i = 0;
      Array.from(e).forEach(file => { 
        var name = ["File.", that.data.name,".", that.$route.params.id.toString(), ".", that.$options.name, ".", i, ".", file.name.split('.').pop()].join('')
        that.form.rptefiledniup = name;
        data.append('files', file, name);
        i++;
      }); 
      /*
      this.$store.dispatch("saveImgFormulario", data)
      .then(()=> { })
      .catch(()=> { });
      */
     
      var config = {
        method: 'post',
        url: 'https://'+this.$store.state.url+':5001/api/Util/Upload',
        headers: {
                'Content-Type': 'multipart/form-data'
        },
        data : data,
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          that.uploadPercentage = percentCompleted
        }
      }     

      this.$axios(config)
      .then(function (response) {
        console.log(response)
      })
      .catch(function (e) {
          console.log(e.message)
      })        
         
    },         
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        
        this.$emit('setSaveForm', {id:"2", form: this.form, index: "3"});
         
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
     
  },
  computed: {
    file:function(){
      try{
        var f = this.form.rptefiledni
        var file = f.split(".")
        var ext = file[file.length -1];
        var images = require.context('../assets/', false, /\.png$/)
        return images('./' + ext + ".png")
        }
      catch(e){
        console.log(e.message)
        return null
      }       

    },
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    showPorcentaje:function(){
      console.log("cp")
      return (this.uploadPercentage == 0 || this.uploadPercentage == 100)
    },
    showPorcentajeSuccess:function(){
      return (this.uploadPercentage == 100)
    }  

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
